module.exports = __webpack_public_path__ + "static/img/WhatYouSeeIs WhatYouGet.5bd6395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WhatYouSeeIs WhatYouGet.png
// module id = uQgl
// module chunks = 1